module.exports = "<div class=\"add-programming\">\n\t<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/add-programming/add-programming.component.html
// module id = 1508
// module chunks = 2